import { Controller } from '@hotwired/stimulus';
import { buildJsonHeaders } from 'utils/csrf_helpers';

export default class extends Controller {
  static targets = ['checkbox', 'link', 'message'];

  static values = {
    enabled: Boolean,
    url: String,
    kioskUrl: String,
  };

  connect() {
    this.sync();
  }

  toggle(event) {
    if (this.isSubmitting) {
      this.sync();
      return;
    }

    this.submit(event.target.checked);
  }

  submit(enabled) {
    this.isSubmitting = true;
    this.checkboxTarget.disabled = true;
    this.showMessage('Saving…', false);

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: buildJsonHeaders(),
      body: JSON.stringify({ enabled }),
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(body => {
            throw { response, body };
          });
        }

        return response.json();
      })
      .then(data => {
        this.enabledValue = data.kiosk_mode;
        this.showMessage(data.message, false);
      })
      .catch(error => {
        let message = 'Unable to update kiosk mode.';

        if (error.body?.errors) {
          message = error.body.errors.join(', ');
        }

        this.showMessage(message, true);
      })
      .finally(() => {
        this.isSubmitting = false;
        this.checkboxTarget.disabled = false;
        this.sync();
      });
  }

  sync() {
    if (!this.hasCheckboxTarget) return;

    this.checkboxTarget.checked = this.enabledValue;

    if (this.hasLinkTarget) {
      this.linkTarget.classList.toggle('d-none', !this.enabledValue);
      if (!this.linkTarget.href) {
        this.linkTarget.href = this.kioskUrlValue;
      }
    }

    if (this.hasMessageTarget && this.messageTarget.textContent.trim() === '') {
      this.messageTarget.hidden = true;
    }
  }

  showMessage(message, isError = false) {
    if (!this.hasMessageTarget) return;

    clearTimeout(this.hideMessageTimeout);

    this.messageTarget.textContent = message;
    this.messageTarget.hidden = !message;
    this.messageTarget.classList.toggle(
      'event-kiosk-toggle__message--error',
      isError
    );

    if (!message) return;

    this.messageTarget.classList.remove(
      'event-kiosk-toggle__message--fade',
      'event-kiosk-toggle__message--flash'
    );

    // Restart animation by forcing a reflow before re-adding the flash class
    // eslint-disable-next-line no-unused-expressions
    this.messageTarget.offsetWidth;

    this.messageTarget.classList.add('event-kiosk-toggle__message--flash');

    this.hideMessageTimeout = setTimeout(() => {
      this.messageTarget.classList.add('event-kiosk-toggle__message--fade');

      this.messageTarget.addEventListener(
        'animationend',
        () => {
          this.messageTarget.hidden = true;
          this.messageTarget.textContent = '';
          this.messageTarget.classList.remove(
            'event-kiosk-toggle__message--flash',
            'event-kiosk-toggle__message--fade'
          );
        },
        { once: true }
      );
    }, 3000);
  }
}
